import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from '../ui';

const FAQ = [
  ['Why was my payment declined?', 'Payments can fail for insufficient funds, incorrect card details, or bank security checks. Verify your details and try again.'],
  ['Was I charged?', 'No. Cancelling during checkout processes no payment. You can safely retry with another card.'],
  ['Can I use a different payment method?', 'Yes — go back to pricing and start checkout again with any major card.'],
];

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="tw-mx-auto tw-max-w-2xl tw-py-8">
      <Card className="tw-text-center">
        <div className="tw-mx-auto tw-mb-4 tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-warn/15 tw-text-2xl tw-text-warn">
          <i className="fa-solid fa-circle-xmark" />
        </div>
        <h1 className="tw-text-xl tw-font-bold tw-text-heading">Payment canceled</h1>
        <p className="tw-mt-2 tw-text-content-muted">Your payment was canceled and you have not been charged.</p>
        <div className="tw-mt-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-3">
          <Button icon="fa-arrow-left" onClick={() => navigate('/pricing')}>Back to Pricing</Button>
          <Button variant="secondary" onClick={() => navigate('/billing')}>View Current Plan</Button>
          <Button variant="ghost" onClick={() => { window.location.href = 'mailto:support@app.teve.ca'; }}>Contact Support</Button>
        </div>
      </Card>

      <div className="tw-mt-8">
        <h2 className="tw-mb-3 tw-text-center tw-text-sm tw-font-bold tw-uppercase tw-tracking-wider tw-text-content-faint">Common questions</h2>
        <div className="tw-space-y-2">
          {FAQ.map(([q, a]) => (
            <details key={q} className="tw-rounded-xl tw-border tw-border-line tw-bg-ink-900 tw-p-4">
              <summary className="tw-cursor-pointer tw-font-semibold tw-text-heading">{q}</summary>
              <p className="tw-mt-2 tw-text-sm tw-text-content-muted">{a}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
